// src/features/dashboard/hooks/Employee/useOverviewCard.ts

import {
  useEffect,
  useState,
} from 'react';

import {
  getOverviewCard,
} from '../../services/Employee/overviewCard.service';

import {
  overviewCardMock,
} from '../../mocks/Employee/overviewCard.mock';

import {
  getPercentageColor,
  getWidth,
} from '../../utils/Employee/overviewCard.utils';

import {
  useDashboardDate,
} from '../../context/DashboardDateContext';

import {
  formatApiDate,
} from '../../utils/date.utils';

import type {
  OverviewCardResponse,
} from '../../types/Employee/overviewCard.types';

import { AuthSession } from '../../../../utils/authSession';

export const useOverviewCard = () => {

   const employeeCode = AuthSession.currentEmployee();

   const {
    fromDate,
    toDate,
  } = useDashboardDate();

  const [
    data,
    setData,
  ] =
    useState<OverviewCardResponse | null>(
      null,
    );

  const [
    loading,
    setLoading,
  ] =
    useState(true);

  useEffect(() => {

    if (!employeeCode) {
  return;
}
    const fetchData =
      async () => {

        try {

          setLoading(
            true,
          );

          const response =
  await getOverviewCard({
    employeeCode,
    fromDate:
      formatApiDate(
        fromDate,
      ),
    toDate:
      formatApiDate(
        toDate,
      ),
  });

          setData({
            ...overviewCardMock,

            items: [
              {
                title:
                  'HOURS · TODAY',

                percent:
                  `${response.hoursTodayPercentage.toFixed(
                    0,
                  )}%`,

                value:
                  response.hoursTodayActual,

                target:
                  `/ ${response.hoursTodayTarget} target`,

                width:
                  getWidth(
                    response.hoursTodayPercentage,
                  ),

                color:
                  getPercentageColor(
                    response.hoursTodayPercentage,
                  ),
              },

              {
                title:
                  'PRODUCTIVITY · TODAY',

                percent:
                  `${response.productivityActual.toFixed(
                    0,
                  )}%`,

                value:
                  `${response.productivityActual.toFixed(
                    0,
                  )}%`,

                target:
                  `/ ${response.productivityPercentage}% target`,

                width:
                  getWidth(
                    response.productivityActual,
                  ),

                color:
                  getPercentageColor(
                    response.productivityActual,
                  ),
              },

              {
                title:
                  'HOURS · WEEK-TO-DATE',

                percent:
                  `${response.weekToDatePercentage.toFixed(
                    0,
                  )}%`,

                value:
                  response.weekToDateActual,

                target:
                  `/ ${response.weekToDateTarget} target`,

                width:
                  getWidth(
                    response.weekToDatePercentage,
                  ),

                color:
                  getPercentageColor(
                    response.weekToDatePercentage,
                  ),
              },
            ],
          });

        } catch (
          error
        ) {

          console.error(
            'Overview Card Error:',
            error,
          );

        } finally {

          setLoading(
            false,
          );
        }
      };

    fetchData();

  }, [
    employeeCode,
    fromDate,
    toDate,
  ]);

  return {
    data,
    loading,
  };
};